import {
  AccredibleResponsiveBreakpoint,
  AccredibleResponsiveHelper,
} from '@accredible-frontend-v2/utils/responsive-helper';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Input,
  NgZone,
  ViewChild,
} from '@angular/core';
import { StateChange } from 'ng-lazyload-image';
import { first } from 'rxjs/operators';

@Component({
  selector: 'accredible-banner-panel',
  templateUrl: './banner-panel.component.html',
  styleUrls: [`./banner-panel.component.scss`],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerPanelComponent implements AfterViewInit {
  @Input()
  bannerHeight: string;
  @Input()
  backgroundGradient: string;
  @Input()
  backgroundImage: string;

  @ViewChild('overlayContent')
  overlayContent: ElementRef<HTMLElement>;

  stack = false;

  constructor(private readonly _el: ElementRef<HTMLElement>, private readonly _zone: NgZone) {}

  @HostBinding('class')
  get classes(): string {
    return this.stack ? 'stack' : '';
  }

  @HostListener('window:resize', [])
  onResize(): void {
    this._setBannerHeight();
  }

  ngAfterViewInit(): void {
    // This fixes ExpressionChangedAfterItHasBeenCheckedError,
    // changing this.stack value while Angular is running change detection is not correct
    // so we wait for zone to be stable and then changing the value will trigger
    // another change detection run and the error will not occur
    this._zone.onStable.pipe(first()).subscribe(() => {
      this.stack = this.overlayContent.nativeElement.childNodes.length > 0;
      this._setBannerHeight();
    });
  }

  lazyLoadOnStatechange(event: StateChange): void {
    switch (event.reason) {
      case 'loading-failed':
        this.backgroundImage = null;
        if (!this.backgroundGradient) {
          this.backgroundGradient = 'linear-gradient(to bottom left, lightgrey, grey)';
        }
        break;
    }
  }

  private _setBannerHeight() {
    this._el.nativeElement.style.height =
      !this.stack ||
      (this.stack &&
        AccredibleResponsiveHelper.isScreenGreaterThan(AccredibleResponsiveBreakpoint.MD))
        ? this.bannerHeight
        : 'auto';
  }
}
